<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'掲示板（スレッド）' | translate}}</h1>

  <div class="middle-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'スレッド' | translate}}</span>
    </button>
  </div>

</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="thread_owner" >
      <th mat-header-cell mat-sort-header *matHeaderCellDef  style="text-align:left" [style.width.px]="85"> {{'投稿者' | translate}} </th>
      <td mat-cell *matCellDef="let boardThread" style="text-align:left" [style.width.px]="65" [style.min-width.px]="65">
        <div *ngIf="boardThread.thread_owner===owner_email">
          <button mat-mini-fab color="primary" (click)="openEditDialog(boardThread)">{{ boardThread.thread_owner |
            slice: 0:3 }} </button>
        </div>
        <div *ngIf="boardThread.thread_owner!==owner_email">
          <button mat-mini-fab color="accent" (click)="openBrowseDialog(boardThread)">{{ boardThread.thread_owner |
            slice: 0:3 }} </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef style="text-align:left" [style.width.px]="85">
        {{'投稿日時' | translate}} </th>
      <td mat-cell *matCellDef="let boardThread" style="text-align:left" [style.width.px]="85"
        [style.min-width.px]="85">
        {{ boardThread.created.toDate() | date: 'yyyy/MM/dd' }}<br>
        {{ boardThread.created.toDate() | date: 'HH:mm:ss' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="thread_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.min-width.px]="200"> {{'名称' |
        translate}} </th>
      <td mat-cell *matCellDef="let boardThread" [style.min-width.px]="200">
        {{ boardThread.thread_name | cutter:30}}
      </td>
    </ng-container>

    <ng-container matColumnDef="thread_desc">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.min-width.px]="300"> {{'内容' |
        translate}} </th>
      <td mat-cell *matCellDef="let boardThread">
        {{ boardThread.thread_desc | cutter:128}}
      </td>
    </ng-container>

    <ng-container matColumnDef="thread_image">
      <th mat-header-cell *matHeaderCellDef style="text-align:left" [style.width.px]="100"> {{'画像' |
        translate}} </th>
      <td mat-cell *matCellDef="let boardThread" style="text-align:left" [style.width.px]="100"
        [style.min-width.px]="100">
        <img *ngIf="!!boardThread.thread_image" [src]="boardThread.thread_image.download_url" height="70px"
          width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="gotoComment">
      <th mat-header-cell *matHeaderCellDef style="text-align:center" [style.width.px]="100"> {{'コメントへ' | translate}} </th>
      <td mat-cell *matCellDef="let boardThread" style="text-align:center" [style.width.px]="80"[style.min-width.px]="80">
        <button mat-icon-button (click)="gotoComment(boardThread)">
          <mat-icon>forward</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>